import { Component, EventEmitter, Input, Output, AfterViewInit } from '@angular/core';
import { ZipCodeRangeModel } from '../../../../shared/models/zip-code-range.model';
import { MobileScrollToService } from '../../../../shared/services/mobile-scroll-to.service';
import { StoreConfigurationsService } from '../../../../shared/services/store-configurations.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    'selector': 'payment-delivery-freights-list',
    'templateUrl': './payment.delivery.freights.list.component.html'
})
export class PaymentDeliveryFreightsListComponent implements AfterViewInit {
    @Input() freights: Array<ZipCodeRangeModel> = [];
    @Output() changed: EventEmitter<ZipCodeRangeModel> = new EventEmitter();
    public deliveryDescription = '';

    constructor(
        private activatedRoute: ActivatedRoute,
        private mobileScrollToService: MobileScrollToService,
        private storeConfigurations: StoreConfigurationsService
    ) {
        this.activatedRoute.data.map((data) => {
            return data.storeConfigurations;
        }).subscribe((data) => {
            if (
                data['checkout-delivery-description'] !== undefined
                && data['checkout-delivery-description'] !== null
            ) {
                this.deliveryDescription = data['checkout-delivery-description'];
            }
        });
    }

    ngAfterViewInit() {
        this.mobileScrollToService.scrollTo('#scroll-to-freights');

        if (this.isFirstOptionDefaultSelected()) {
            this.onChangedFreight(this.freights[0]);
        }
    }

    /**
     * First freight option must be selected as default when only one
     * options is provided by API.
     **/
    public isFirstOptionDefaultSelected() {
        return this.freights.length === 1;
    }
    /**
     * Emit changed event
     **/
    public onChangedFreight(freight: ZipCodeRangeModel) {
        this.changed.emit(freight);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/payment/delivery/freights/list/payment.delivery.freights.list.component.ts